import config from 'favoris-web/config/environment';

/**
 * Resolve a relative API path to an absolute URL when FAVORIS_API_HOST is set.
 * In development (no host configured) the path is returned unchanged so the
 * Vite proxy can handle it.
 */
export function toApiUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;

  const host = config.favoris.apiHost;
  if (!host) return path;

  const normalizedHost = host.endsWith('/') ? host.slice(0, -1) : host;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedHost}${normalizedPath}`;
}

/**
 * Fetch wrapper that resolves API URLs through the configured host.
 * Drop-in replacement for `fetch(toApiUrl(path), init)`.
 */
export function apiFetch(url: string, init?: RequestInit): Promise<Response> {
  // eslint-disable-next-line warp-drive/no-external-request-patterns -- centralized fetch wrapper
  return fetch(toApiUrl(url), init);
}
